// AlignUI useBreakpoint v0.0.0
//
// Лежит рядом со столбиками, а не в общем месте: больше его никто не зовёт, а общая папка
// хуков ради одного файла — новая поверхность на пустом месте.

import { useEffect, useState } from 'react';

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

type BreakpointKeys = keyof typeof breakpoints;

const useBreakpoint = () => {
  const isBrowser = typeof window !== 'undefined';

  const initialState = isBrowser
    ? Object.keys(breakpoints).reduce(
        (acc, key) => ({
          ...acc,
          [key]: window.innerWidth >= breakpoints[key as BreakpointKeys],
        }),
        {} as Record<BreakpointKeys, boolean>,
      )
    : ({} as Record<BreakpointKeys, boolean>);

  const [currentBreakpoints, setCurrentBreakpoints] = useState(initialState);
  const [prevBreakpoints, setPrevBreakpoints] = useState(initialState);

  useEffect(() => {
    if (!isBrowser) return undefined;

    const handleResize = () => {
      const windowWidth = window.innerWidth;

      const newBreakpoints = Object.keys(breakpoints).reduce(
        (acc, key) => ({
          ...acc,
          [key]: windowWidth >= breakpoints[key as BreakpointKeys],
        }),
        {} as Record<BreakpointKeys, boolean>,
      );

      if (JSON.stringify(prevBreakpoints) !== JSON.stringify(newBreakpoints)) {
        setCurrentBreakpoints(newBreakpoints);
        setPrevBreakpoints(newBreakpoints);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [prevBreakpoints, isBrowser]);

  return currentBreakpoints;
};

export default useBreakpoint;
